import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUserSiteAccessedInformation } from "../../services/user-role-administration-service/Models";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseUserListReportParameters = {
    organizationID: number;
    groupID: number;
} & BaseUseQueryParameters<IUserSiteAccessedInformation[]>;

export function useUserListReport({
    organizationID,
    groupID,
    enabled,
    onError,
    onSuccess
}: UseUserListReportParameters) {
    return useQuery<IUserSiteAccessedInformation[], RestError, IUserSiteAccessedInformation[]>(
        keys.userListReport(organizationID, groupID),
        ({ signal }) => {
            return UserRoleAdministrationService.getUserListReport(organizationID, groupID, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            staleTime: 0
        }
    );
}
